import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/routers/constant'

const router: Array<RouteRecordRaw> = [
  {
    path: '/business/consume',
    component: Layout,
    redirect: '/business/consume/inventory/index',
    meta: {
      title: '耗材管理',
      keepAlive: true,
      requiresAuth: true
    },
    children: [
      {
        path: 'inventory/index',
        name: 'BusinessConsumeInventoryIndex',
        component: () => import('@/views/business/consume/inventory/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '耗材库存管理'
        }
      },
      {
        path: 'distribute/index',
        name: 'BusinessConsumeDistributeIndex',
        component: () => import('@/views/business/consume/distribute/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '消耗记录'
        }
      },
      {
        path: 'apply/index',
        name: 'BusinessConsumeApplyIndex',
        component: () => import('@/views/business/consume/apply/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '申领管理'
        }
      }
    ]
  }
]

export default router
